export const getShippingDisplayText = (type, t) => {
    switch (type) {
        case 'Alternative':
            return t('shippingInfo_alternativeShippingOption');
        case 'Bussgods':
            return 'Bussgods';
        case 'DHL':
            return 'DHL';
        case 'FedEx':
            return 'FedEx';
        case 'NotSpecified':
            return t('shippingInfo_notSpecified');
        case 'Posten':
            return 'PostNord';
        case 'PostNordParcel':
            return t('shippingInfo_postNordParcel');
        case 'PostNordStamp':
            return t('shippingInfo_postNordStamp');
        case 'SchenkerPrivpak':
            return 'DB Schenker';
        case 'Takeaway':
            return t('shippingInfo_pickup');
        case 'TakeawayOnly':
            return t('shippingInfo_pickupOnly');
        case 'UPS':
            return 'Ups';
        default:
            return type;
    }
};
